import { CalendarClock, FlaskConical, Wallet, Zap } from "lucide-react";
import type { StammdatenTabDef } from "@/pages/stammdaten/StammdatenTabNav";

export type SettingsTab = "buchung" | "zahlung" | "strom" | "testsystem";

export const SETTINGS_TABS: StammdatenTabDef<SettingsTab>[] = [
  {
    id: "buchung",
    label: "Buchung & Aufenthalt",
    shortLabel: "Buchung",
    description:
      "Standard-Nächte je Gästetyp, Abreise-Uhrzeit und Check-out-Regeln sowie die Belegungszahlen auf dem Dashboard.",
    icon: CalendarClock,
  },
  {
    id: "zahlung",
    label: "Anzahlung & Preise",
    shortLabel: "Zahlung",
    description:
      "Anzahlungssystem, Dynamic Pricing und Frühbucher, Zahlungsziel und wann Touristen abgerechnet werden.",
    icon: Wallet,
  },
  {
    id: "strom",
    label: "Strom-Abrechnung",
    shortLabel: "Strom",
    description: "Wie Strom berechnet wird: pauschal pro Nacht, nach Verbrauch oder Pauschale mit Freimenge.",
    icon: Zap,
  },
  {
    id: "testsystem",
    label: "Admin",
    shortLabel: "Admin",
    description:
      "Auf Production veröffentlichen, Demodaten, Testdaten löschen und Schulungswerkzeuge – nur auf Dev- und Test-Systemen.",
    icon: FlaskConical,
  },
];

export function parseSettingsTab(value: string | null): SettingsTab {
  if (value === "zahlung" || value === "strom" || value === "testsystem") return value;
  return "buchung";
}

export function settingsTabHref(tab: SettingsTab): string {
  return tab === "buchung" ? "/stammdaten/einstellungen" : `/stammdaten/einstellungen?tab=${tab}`;
}
